// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"6394799f","453":"df2c82dc","455":"cdf735d7","535":"cab71185","575":"ba672529","873":"88352345"}[chunkId] + ".chunk.js";
};